<template>
	<div class="signature-popup-view">
		<div class="section">
			<div class="heading">Leveret</div>
			<div class="items">
				<div v-for="(it, i) in items" :key="i" class="item">
					<div class="label">{{ it.label }}</div>
					<div class="qty">{{ it.qty }}</div>
				</div>
			</div>
		</div>

		<div class="liability">{{ liability }}</div>

		<div class="section">
			<div class="heading">
				Underskrift
				<div class="clear" @click.stop="clear">Ryd</div>
			</div>
			<canvas
				ref="canvas"
				class="pad"
				@pointerdown="start"
				@pointermove="move"
				@pointerup="end"
				@pointerleave="end"
			></canvas>
		</div>

		<div class="section receipt">
			<div class="row" @click.stop="model.opt_in = !model.opt_in">
				<div class="label">Send kvittering på email</div>
				<switch-view style="display: inline-block;" v-model="model.opt_in" />
			</div>
			<div class="row email" v-if="model.opt_in">
				<div class="value">Sendes til: {{ model.email || 'ingen e-mail på kunden' }}</div>
			</div>
		</div>
	</div>
</template>

<script>
	import SwitchView from '@/components/SwitchView'

	export default {
		name: 'signature-popup-view',
		props: ['title', 'items', 'liability', 'model', 'actions'],
		components: {
			SwitchView
		},
		data() {
			return {
				drawing: false,
				ctx: null,
				last: null
			};
		},
		mounted() {
			var c = this.$refs.canvas;

			var w = c.clientWidth || 320;
			var h = c.clientHeight || 180;

			c.width = w;
			c.height = h;

			var ctx = c.getContext('2d');
			ctx.fillStyle = '#ffffff';
			ctx.fillRect(0, 0, w, h);
			ctx.lineWidth = 2.5;
			ctx.lineCap = 'round';
			ctx.lineJoin = 'round';
			ctx.strokeStyle = '#000000';

			this.ctx = ctx;
		},
		methods: {
			pos(e) {
				var r = this.$refs.canvas.getBoundingClientRect();
				return { x: e.clientX - r.left, y: e.clientY - r.top };
			},
			start(e) {
				e.preventDefault();
				this.drawing = true;
				this.last = this.pos(e);
			},
			move(e) {
				if (!this.drawing) return;
				e.preventDefault();

				var p = this.pos(e);

				this.ctx.beginPath();
				this.ctx.moveTo(this.last.x, this.last.y);
				this.ctx.lineTo(p.x, p.y);
				this.ctx.stroke();

				this.last = p;
			},
			end() {
				if (!this.drawing) return;
				this.drawing = false;
				this.model.signature = this.$refs.canvas.toDataURL('image/png');
			},
			clear() {
				var c = this.$refs.canvas;
				this.ctx.fillStyle = '#ffffff';
				this.ctx.fillRect(0, 0, c.width, c.height);
				this.model.signature = null;
			}
		}
	}
</script>

<style lang="scss" scoped>
	.signature-popup-view {
		background-color: rgb(236, 236, 236);
		display: grid;
		row-gap: 1px;

		.section {
			background-color: white;
			padding: 16px 20px;

			& > .heading {
				font-weight: bold;
				margin-bottom: 10px;
				display: flex;
				justify-content: space-between;
				align-items: center;

				& > .clear {
					font-weight: normal;
					color: #f7223f;
				}
			}
		}

		.items {
			& > .item {
				display: grid;
				grid-template-columns: 1fr auto;
				line-height: 32px;

				& > .qty {
					text-align: right;
				}
			}
		}

		.liability {
			background-color: white;
			padding: 16px 20px;
			font-size: 13px;
			color: #555;
		}

		.pad {
			width: 100%;
			height: 180px;
			border: 1px solid #ddd;
			border-radius: 4px;
			touch-action: none;
			display: block;
		}

		.receipt {
			& > .row {
				display: grid;
				grid-template-columns: 1fr auto;
				align-items: center;
				line-height: 48px;

				&.email {
					grid-template-columns: 1fr;

					& > .value {
						color: #555;
					}
				}
			}
		}
	}
</style>
